import { component } from 'picoapp'

/* function to apply styling to anchor button */
export default component((node) => {
  /* declare variables */
  const parentContainer = document.querySelector('[data-faq-anchor]').closest('section')
  const anchorButtons = document.querySelectorAll('[data-faq-anchor]')

  // set top attribute for sticky anchor container on page load
  window.addEventListener('load', () => {
    const headerHeight = document.querySelector('.js-main-header').getBoundingClientRect().height
    parentContainer.setAttribute('style', `top:${headerHeight}px`)
  })
  // add resize event
  window.addEventListener('resize', resizeHeaderHeight)
  //add node event
  node.addEventListener('click', anchorButtonClick)

  // set top attribute for sticky anchor on resize
  function resizeHeaderHeight() {
    const resizedHeaderHeight = document.querySelector('.js-main-header').getBoundingClientRect().height
    parentContainer.setAttribute('style', `top:${resizedHeaderHeight}px`)
  }

  function anchorButtonClick() {
    anchorButtons.forEach((anchor) => {
      // clear selected styling
      anchor.setAttribute('aria-pressed', 'false')
      // get id for targeted element
      const anchorLink = anchor.getAttribute('href')
      const anchorURL = new URL(anchorLink, window.location.origin)
      const anchorID = anchorURL.hash.split('#')
      if (anchorID) {
        setScrollMarginTop(anchorID[1])
      }
    })
    // apply selected styling
    node.setAttribute('aria-pressed', 'true')
  }

  return () => {
    //remove events
    node.removeEventListener('click', anchorButtonClick)
    window.removeEventListener('resize', resizeHeaderHeight)
  }
})

// function to set scroll margin top styling on targeted element
function setScrollMarginTop(elementId) {
  const parentContainer = document.querySelector('[data-faq-anchor]').closest('section')
  const headerHeight = document.querySelector('.js-main-header').getBoundingClientRect().height
  const parentHeight = parentContainer.getBoundingClientRect().height
  const heightSum = headerHeight + parentHeight - 1
  document.querySelector(`div#${elementId}`).setAttribute('style', `scroll-margin-top:${heightSum}px`)
}
